// extracted by mini-css-extract-plugin
export var hideEditor = "_iy-2";
export var infoIcon = "_iy-3";
export var label = "_iy-1";
export var labelContainer = "_iy-0";
export var readonlyText = "_iy-4";